export class ConfigConstant {
    constructor(public readonly namespace: string, public readonly constant: Readonly<Record<string, unknown>>) {}
}
